













import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import { getQueryVariable } from '../common/common';
import ReportHeader from '../components/ReportHeader.vue';
import ReportFooter from '../components/ReportFooter.vue';
import CheckInfo from '../components/CheckInfo.vue';
import CheckLimit from '../components/CheckLimit.vue';
import CheckResult from '../components/CheckResult.vue';
import CheckResultDetail from '../components/CheckResultDetail.vue';
import SimilarList from '../components/SimilarList.vue';
import Explain from '../components/Explain.vue';

export default Vue.extend({
  name: 'Simple',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo
  }),
  components: {
    ReportHeader,
    ReportFooter,
    CheckInfo,
    CheckLimit,
    CheckResult,
    CheckResultDetail,
    SimilarList,
    Explain
  },
  data() {
    return {
      checkResult: {}
    };
  },
  methods: {
    // 获取检测报告数据
    getData() {
      if (JSON.stringify(this.checkInfo) === '{}') {
        this.$store.dispatch('setCheckInfo');
      }
    }
  },
  mounted() {
    this.getData();
  }
});
